import { useMemo } from 'react';

import useMemoSelector from 'hooks/useMemoSelector';

import { getUserData } from 'store/selectors/general';

type UseAuthInfoReturnType = {
  isProOrGoldUser?: boolean;
  isAuthorized?: boolean;
  waitingUserSubscription?: boolean;
};

const PLUS_TIER_ID = 'plus';

function useAuthInfo(): UseAuthInfoReturnType {
  const { isAuthorized, subscriptionType, tiers, waitingUserSubscription } = useMemoSelector(getUserData);

  const isProOrGoldUser = useMemo(() => {
    if (!subscriptionType) return false;

    if (!tiers?.length) return false;

    const plusTier = tiers.find(tier => tier.id === PLUS_TIER_ID);
    const userTier = tiers.find(tier => tier.id === subscriptionType);

    if (!plusTier || !userTier) return false;

    return userTier.level > plusTier.level;
  }, [subscriptionType, tiers]);

  return {
    isProOrGoldUser,
    isAuthorized,
    waitingUserSubscription,
  };
}

export default useAuthInfo;
